import { HttpApiError } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { ConversationThreadId, MessageId } from "../ids/definitions";
import { ConversationGroupBase } from "./conversation";

export const ConversationGroup = ConversationGroupBase.add(
  endpoint.merchant
    .post(
      "toggleCommentVisibility",
      "/conversations/comments/toggle-visibility",
    )
    .setPayload(
      Schema.Struct({
        threadId: ConversationThreadId,
        messageId: MessageId,
        commentId: Schema.String,
        platform: Schema.Literal("facebook", "instagram"),
        hide: Schema.Boolean,
      }),
    )
    .addSuccess(Schema.Struct({ success: Schema.Boolean }))
    .addError(HttpApiError.Forbidden)
    .addError(HttpApiError.BadRequest)
    .addError(DatabaseError)
    .addError(DataIntegrityError),
)
  .add(
    endpoint.merchant
      .post("deleteComment", "/conversations/comments/delete")
      .setPayload(
        Schema.Struct({
          threadId: ConversationThreadId,
          messageId: MessageId,
          commentId: Schema.String,
          platform: Schema.Literal("facebook", "instagram"),
        }),
      )
      .addSuccess(Schema.Struct({ success: Schema.Boolean }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("likeComment", "/conversations/comments/like")
      .setPayload(
        Schema.Struct({
          threadId: ConversationThreadId,
          messageId: MessageId,
          commentId: Schema.String,
        }),
      )
      .addSuccess(Schema.Struct({ success: Schema.Boolean }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("unlikeComment", "/conversations/comments/unlike")
      .setPayload(
        Schema.Struct({
          threadId: ConversationThreadId,
          messageId: MessageId,
          commentId: Schema.String,
        }),
      )
      .addSuccess(Schema.Struct({ success: Schema.Boolean }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("updateComment", "/conversations/comments/update")
      .setPayload(
        Schema.Struct({
          threadId: ConversationThreadId,
          messageId: MessageId,
          commentId: Schema.String,
          newMessage: Schema.String,
        }),
      )
      .addSuccess(Schema.Struct({ success: Schema.Boolean }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
